import { render, staticRenderFns } from "./DecreaseTableComponent.vue?vue&type=template&id=263ae63f&scoped=true"
import script from "./DecreaseTableComponent.vue?vue&type=script&lang=js"
export * from "./DecreaseTableComponent.vue?vue&type=script&lang=js"
import style0 from "./DecreaseTableComponent.vue?vue&type=style&index=0&id=263ae63f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "263ae63f",
  null
  
)

export default component.exports